document.querySelectorAll('.news-list[data-news]').forEach((list) => {
  let page = 1;
  const perPage = 12;
  const container = list.querySelector('.cards-grid__container');
  let items = list.querySelectorAll('.news-card');
  const loadMoreButton = list.querySelector('.news-list__load-more-button');

  if (loadMoreButton) {
    if (items.length < perPage) {
      loadMoreButton.style.display = 'none';
    }

    loadMoreButton.addEventListener('click', () => {
      page++;

      loadMoreButton.disabled = true;

      fetch(`${ajaxurl}?action=get_news&page=${page}`)
        .then((response) => response.json())
        .then((data) => {
          container.innerHTML += data.data;

          items = list.querySelectorAll('.news-card');

          if (items.length < perPage * page) {
            loadMoreButton.style.display = 'none';
          } else {
            loadMoreButton.disabled = false;
          }
        });
    });
  }
});